import PropTypes from "prop-types";
import { Dialog, IconButton, Link, Typography } from "@material-ui/core";
import { styled } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import * as React from "react";
import { useMatchesSmDown } from "../../hooks";

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  left: theme.spacing(0.5),
  top: theme.spacing(0.5),
  zIndex: 10,
}));
const StyledDialog = styled(Dialog)(({ theme }) => ({
  width: "auto",
  "& .MuiDialog-paperWidthSm": {
    maxWidth: "fit-content",
  },
  [theme.breakpoints.down("sm")]: {
    "& .MuiDialog-paperWidthSm": {
      maxWidth: "90vw",
      margin: "0",
    },
  },
}));

export default function AccessoryDetails({ imageUrl }) {
  const [open, setOpen] = React.useState(false);
  const isMobile = useMatchesSmDown();
  const size = isMobile ? "100%" : "600px";

  return (
    <>
      <Link
        component="button"
        type="button"
        onClick={(evt) => {
          evt.preventDefault();
          evt.stopPropagation();
          setOpen(true);
        }}
      >
        <Typography
          variant="caption"
          style={{ color: "#2A6FC0", textDecoration: "underline" }}
        >
          See more
        </Typography>
      </Link>

      <StyledDialog open={open} onClose={() => setOpen(false)}>
        <StyledIconButton
          onClick={() => setOpen(false)}
          aria-label="Close"
          style={{ right: "4px", left: "auto" }}
        >
          <CloseIcon style={{ color: "silver" }} />
        </StyledIconButton>
        <img src={imageUrl} style={{ width: size, height: size }} />
      </StyledDialog>
    </>
  );
}

AccessoryDetails.propTypes = {
  imageUrl: PropTypes.string.isRequired,
};
